import { defineComponent, PropType } from 'vue';
import { blockContentToVue } from './block-content-to-vue';
import { OptionBlocks, OptionSerializers } from './types';

export const blockContentComponent = defineComponent({
  props: {
    blocks: {
      type: [Array, Object] as PropType<OptionBlocks>,
      required: true,
    },
    serializers: {
      type: Object as PropType<OptionSerializers>,
      default: () => ({}),
    },
    projectId: {
      type: String,
      default: undefined,
    },
    dataset: {
      type: String,
      default: undefined,
    },
    imageOptions: {
      type: Object,
      default: () => ({}),
    },
    className: {
      type: String,
      default: '',
    },
    renderContainerOnSingleChild: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return () => blockContentToVue(props);
  },
});
